module.exports = __webpack_public_path__ + "static/media/img011.75af80cb.jpg";